import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButtonModule } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'

import { MatIconModule } from '@angular/material/icon'
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion'
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatTableModule } from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { DriverService } from '../../../core/services/driver/driver/driver.service'
import { ScheduleDriverService } from '../../../core/services/schedule/schedule-driver/schedule-driver.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { SelectionModel } from '@angular/cdk/collections'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { PaginationComponent } from "../../../shared/components/pagination/pagination.component";
import { EscalaFrotaService } from '../../../core/services/schedule/escala-frota/escala-frota.service'
import { CODIGO_EXCLUSAO_LABEL, identificacaoCandidato } from '../../../core/models/escala-frota.model'

@Component({
  selector: 'app-schedule-driver',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormField,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatDatepicker,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginator,
    MatSelectModule,
    MatOptionModule,
    MatProgressSpinner,
    MatTooltipModule,
    MatCheckboxModule,
    PaginationComponent,
    MatProgressBar
  ],
  templateUrl: './schedule-driver.component.html',
  styleUrl: './schedule-driver.component.scss',
  standalone: true,
})
export class ScheduleDriverComponent implements OnInit {
  constructor(
    private driverService: DriverService,
    private formBuilder: FormBuilder,
    private scheduleDriverService: ScheduleDriverService,
    private escalaFrotaService: EscalaFrotaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService
  ) { }

  @Input() dataDriver: any
  @Input() view: any

  codigoExclusaoLabel = CODIGO_EXCLUSAO_LABEL
  identificacaoCandidato = identificacaoCandidato
  carregandoSugestao = false
  sugestao: any = null

  selectionActive: any = false
  form!: FormGroup;
  itemsList: any[] = [];
  loading = false;
  disableButton = false;
  listTypeDriver: any[] = []
  selection = new SelectionModel<any>(false, []);


  listSearch: any = [
    {
      value: 'nome',
      description: 'Nome'
    },
    {
      value: 'numeroRegistro',
      description: 'Número de Registro'
    },
    {
      value: 'categoria',
      description: 'Categoria'
    },
    {
      value: 'cpf',
      description: 'CPF'
    },
    {
      value: 'matricula',
      description: 'Matricula'
    },
  ]

  @Output() response = new EventEmitter<any>()
  @Output() checkboxChange = new EventEmitter<any>()
  editIndex: number | null = null;
  editAgendaItem: any = null;
  page = 1
  rows = 10
  numberRows = 0
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  displayedColumns: string[] = [
    'select',
    'name',
    'cpf',
    'typeDescriptionDriver',
    'category',
    // 'action'
  ]
  columns: any[] = [
    { keyColumn: 'select', key: 'selectItem', description: 'Selecionar' },
    { keyColumn: 'name', key: 'nomeFuncionario', description: 'Razão Social' },
    { keyColumn: 'cpf', key: 'numeroRegistro', description: 'CPF' },
    { keyColumn: 'category', key: 'categoria', description: 'Categoria' },
    { keyColumn: 'typeDescriptionDriver', key: 'descricaoTipoMotorista', description: 'Tipo Motorista' },
    // { keyColumn: 'action', key: { edit: false, delete: true }, description: 'Ações' },
  ]



  ngOnInit(): void {
    this.createForm()
    if (this.dataDriver.viewMode) {
      this.getListDriverByOs()
    } else {
      this.getListDriver()
    }

    if (this.dataDriver.item.agendaMotoristaId) {
      this.fillForm()
    }

    if (this.selection.selected.length > 0) {
      this.selectionActive = true
    } else {
      this.selectionActive = false
    }
  }

  private restoreSelection(newList: any[]) {
    // Supondo que cada item tem um id único chamado 'id'
    const selectedIds = this.selection.selected.map(item => item.cpf)
    newList.forEach(item => {
      if (selectedIds.includes(item.cpf)) {
        this.selection.select(item)
      }
    })
  }

  onSelectRow(element: any, checked: boolean) {
    this.checkboxChange.emit(element)

    if (checked) {
      this.selectionActive = true
      this.selection.toggle(element)
      this.form.patchValue({
        typeDriver: element.descricaoTipoMotorista,
        name: element.nomeFuncionario,
        cpf: element.numeroRegistro,
      })
      const item = {
        motoristaId: this.selection.selected[0].id,
        dataInicio: this.data.item.dataInicio,
        horaInicio: this.data.item.horaInicio, // Formata a hora de início
        dataFinal: this.data.item.dataFinal,
        horaFinal: this.dataDriver.item.horaFinal,    // Formata a hora final
        ordemServicoId: this.dataDriver.item.codigoOs
      }
      const itemEdit = {
        id: this.dataDriver.item.agendaMotoristaId,
        motoristaId: this.selection.selected[0].id,
        dataInicio: this.data.item.dataInicio,
        horaInicio: this.data.item.horaInicio, // Formata a hora de início
        dataFinal: this.data.item.dataFinal,
        horaFinal: this.dataDriver.item.horaFinal,    // Formata a hora final
        ordemServicoId: this.dataDriver.item.codigoOs
      }

      if (this.dataDriver.item.status === 5) {
        this.response.emit(itemEdit)
      } else {
        this.response.emit(item)
      }

    } else {
      this.selectionActive = false
    }
  }


  sugerirMotorista(): void {
    const osId = this.dataDriver?.item?.codigoOs
    if (!osId) return
    this.carregandoSugestao = true
    this.escalaFrotaService.sugerir(osId).subscribe({
      next: (res: any) => {
        this.sugestao = res.data
        this.carregandoSugestao = false
      },
      error: (err: any) => {
        this.carregandoSugestao = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  // Monta uma "linha" no formato da lista de livres pra reaproveitar onSelectRow —
  // numeroRegistro é o que preenche o campo CPF do topo (ver onSelectRow).
  selecionarSugerido(candidato: any): void {
    this.onSelectRow({
      id: candidato.motoristaId,
      nomeFuncionario: candidato.nome,
      numeroRegistro: candidato.cpf ?? '',
      descricaoTipoMotorista: candidato.tipoMotorista ?? '',
    }, true)
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      typeSearch: ['', [Validators.required]],
      name: ['', [Validators.required]],
      typeDriver: ['', [Validators.required]],
      cpf: ['', [Validators.required]],
      motorista: ['', [Validators.required]],
      search: ['', [Validators.required]],
    })
  }

  searchItem() {
    this.loading = true
    const selectedIds = this.selection.selected.map(item => item.cpf)

    const type = this.form.get('typeSearch')?.value
    let item = {}
    if (type === 'numeroRegistro') {
      item = {

        tipoMotoristaId: 0,
        numeroRegistro: this.form.get('search')?.value,
        categoria: '',
        isfuncionario: '',
        nome: '',
        cpf: '',
        matricula: ''

      }
    } else if (type === 'nome') {
      item = {
        tipoMotoristaId: 0,
        numeroRegistro: '',
        categoria: '',
        isfuncionario: '',
        nome: this.form.get('search')?.value,
        cpf: '',
        matricula: ''
      }
    } else if (type === 'categoria') {
      item = {
        tipoMotoristaId: 0,
        numeroRegistro: '',
        categoria: this.form.get('search')?.value,
        isfuncionario: '',
        nome: '',
        cpf: '',
        matricula: ''
      }
    } else if (type === 'cpf') {
      item = {
        tipoMotoristaId: 0,
        numeroRegistro: '',
        categoria: '',
        isfuncionario: '',
        nome: '',
        cpf: this.form.get('search')?.value,
        matricula: ''
      }
    } else if (type === 'matricula') {
      item = {
        tipoMotoristaId: 0,
        numeroRegistro: '',
        categoria: '',
        isfuncionario: '',
        nome: '',
        cpf: '',
        matricula: this.form.get('search')?.value,
      }
    }

    this.driverService.searchPagedDriver(this.page, this.rows, item).subscribe({
      next: (res) => {
        this.itemsList = res.data
        // this.snackbar.success(res.message)
        this.loading = false
        this.restoreSelection(this.itemsList)
      },
      error: (err) => {
        this.snackbar.error(err.message)
        this.loading = false
      },
    })
  }

  EditItemToList() {
    // this.loading = true;
    // const formValue = this.form.value;
    // this.disableButton = true
    // const dateInitialStr = formValue.dateInitial
    //   ? new Date(formValue.dateInitial).toLocaleDateString('pt-BR')
    //   : '';
    // const dateFinalStr = formValue.dateEnd
    //   ? new Date(formValue.dateEnd).toLocaleDateString('pt-BR')
    //   : '';

    // // Função para formatar a hora no formato hh:MM:ss
    // const formatTime = (timeString: string) => {
    //   if (!timeString) return '';

    //   // Remove qualquer caractere não numérico
    //   const numericTime = timeString.replace(/\D/g, '');

    //   // Garante que temos pelo menos 4 dígitos (hhmm)
    //   const paddedTime = numericTime.padStart(4, '0');

    //   // Formata para hh:MM:ss
    //   return `${paddedTime.substr(0, 2)}:${paddedTime.substr(2, 2)}:00`;
    // };



    // const itemEdit = {
    //   id: this.dataDriver.item.agendaMotoristaId,
    //   motoristaId: this.selection.selected[0].id,
    //   dataInicio: this.data.item.dataInicio,
    //   horainicio: this.data.item.horaInicio, // Formata a hora de início
    //   dataFinal: this.data.item.dataFinal,
    //   horaFinal: this.dataDriver.item.horaFinal,    // Formata a hora final
    //   ordemServicoId: this.dataDriver.item.codigoOs
    // };



    // if (!this.dataDriver.item.agendaMotoristaId) {
    //   this.scheduleDriverService.createAgendaMotorista(item).subscribe({
    //     next: (res) => {
    //       this.snackbar.success(res.message)
    //       this.disableButton = false
    //       this.loading = false
    //       this.response.emit(true)
    //     },
    //     error: (err) => {
    //       this.snackbar.error(err.message)
    //       this.loading = false
    //     }
    //   });
    // } else {
    //   this.scheduleDriverService.editAgendaMotorista(itemEdit).subscribe({
    //     next: (res) => {
    //       this.snackbar.success('Agendamento do motorista editado com sucesso')
    //       this.disableButton = false
    //       this.loading = false
    //       this.response.emit(true)
    //     },
    //     error: (err) => {
    //       console.error('Ocorreu um erro ao editar o agendamento do motorista', err)
    //       this.loading = false
    //     }
    //   });

    // }
  }

  getListDriver() {
    const item = { ordemServicoId: this.dataDriver.item.codigoOs }

    this.scheduleDriverService.listPagedFreeDriver(this.page, this.rows, item).subscribe({
      next: (res: any) => {
        this.itemsList = res.data
        this.restoreSelection(this.itemsList)
        this.getListDriverIsPresent()
        this.numberRows = res.data.totalItens
      },
      error: (err: any) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      }
    })
  }

  getListDriverByOs() {
    this.loading = true
    const item = { ordemServicoId: this.dataDriver.item.codigoOs }
    this.scheduleDriverService.listPagedScheduleDriverByOs(this.page, this.rows, item).subscribe({
      next: (res: any) => {
        if (res.data === null) return
        this.loading = false
        this.itemsList = res.data
        this.numberRows = res.data.totalItens
        this.selection.clear()
        this.itemsList.forEach(item => this.selection.select(item));
      },
      error: (err: any) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      }
    })
  }

  getListDriverIsPresent() {
    const item = { ordemServicoId: this.dataDriver.item.codigoOs }
    this.scheduleDriverService.listPagedScheduleDriverByOs(this.page, this.rows, item).subscribe({
      next: (res: any) => {
        if (res.data === null) return

        this.itemsList.forEach(item => {
          if (item.id === res.data[0].id) {
            this.checkboxChange.emit(res.data[0])
            this.selection.select(item)
            this.selectionActive = true
          }
        });
      },
      error: (err: any) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      }
    })
  }


  editItem(item: any) {
    this.editIndex = this.itemsList.findIndex(
      i => i.date === item.date && i.startDate === item.startDate && i.endDate === item.endDate
    );
    this.editAgendaItem = { ...item };
    this.form.patchValue({
      date: item.date,
      startHours: item.startDate,
      endHours: item.endDate,
    })
  }

  deleteItem(item: any) {
    this.scheduleDriverService.deleteAgendaMotorista(item.id).subscribe({
      next: (res) => {
        this.snackbar.success(res.message)
        this.getListDriverByOs()
      },
      error: (err) => {
        console.error('Ocorreu um erro ao deletar o agendamento do motorista', err)
      }
    })
  }

  saveEditAgendaItem() {
    if (this.editIndex !== null) {
      const formValue = this.form.value;
      this.itemsList[this.editIndex] = {
        date: formValue.date ? new Date(formValue.date).toLocaleDateString('pt-BR') : '',
        startDate: formValue.startHours,
        endDate: formValue.endHours,
      };
      this.itemsList = [...this.itemsList];
      this.editIndex = null
      this.editAgendaItem = null

      this.form.patchValue({
        date: '',
        startHours: '',
        endHours: '',
      });
    }
  }

  reateForm(): void {
    this.form = this.formBuilder.group({
      dateInitial: [''],
      dateEnd: [''],
      startHours: [''],
      endHours: [''],
      motorista: [''],
    })
  }


  resetForm() {

    const selectedIds = this.selection.selected.map(item => item.cpf)

    this.form.get('search')?.setValue('')

    const item = {
      tipoMotoristaId: 0,
      numeroRegistro: '',
      categoria: '',
      isfuncionario: '',
      nome: '',
      cpf: '',
      matricula: ''
    }

    this.driverService.searchPagedDriver(this.page, this.rows, item).subscribe({
      next: (res) => {
        this.itemsList = res.data
        this.snackbar.success(res.message)
        this.loading = false

        this.restoreSelection(this.itemsList)
      }
    })
  }

  parseDateBR(dateStr: string): Date | null {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('/');
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  cancel() {
    this.editIndex = null
    this.response.emit(0)
  }

  treatDate(dateStr: any): Date | null {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('/');
    return new Date(year, month - 1, day);
  }



  fillForm() {
    this.scheduleDriverService.getAgendaMotoristabyId(this.dataDriver.item.agendaMotoristaId).subscribe({
      next: (res) => {
        this.form.patchValue({
          name: res.data.nome,
          typeDriver: res.data.descricaoTipoMotorista,
          cpf: res.data.cpf,
        })
      },
      error: (err) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      }
    })
  }

}
